import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/cashregisterregister";

  searchRegisterReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {
    let sanitizedQuery = query != null ? query.split("'").join('') : null;
    if (sanitizedQuery && (sanitizedQuery.includes('a.updatedDate') || sanitizedQuery.includes('updatedDate'))) {
      sanitizedQuery = sanitizedQuery.replace(/a\.updatedDate/g, 'a.closedAt').replace(/updatedDate/g, 'closedAt');
    }

    const requestBody = {
      "searchQuery": sanitizedQuery
    };

    const p = (page !== undefined && page !== null && String(page) !== 'undefined' && String(page) !== '') ? page : 0;
    const s = (size !== undefined && size !== null && String(size) !== 'undefined' && String(size) !== '') ? size : 10;
    const sortVal = (sort && String(sort) !== 'undefined' && String(sort).trim() !== '' && !String(sort).startsWith(',')) ? sort : 'a.id,desc';
    const queryParams = `?page=${p}&size=${s}&sort=${sortVal}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  downloadapproveTransactions(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getapproveTransactions(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
